import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhatYouGet } from './components/WhatYouGet';
import { Benefits } from './components/Benefits';
import { FaqSection } from './components/FaqSection';
import { InstantAccess } from './components/InstantAccess';
import { Guarantee } from './components/Guarantee';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
interface AppProps {
  /** Show the limited-offer countdown block under the What You Get CTA. */
  showUrgencyBanner?: boolean;
  /** Full-bleed stadium hero, or a split hero led by the product bundle. */
  heroVariant?: 'stadium' | 'bundle';
}
export function App({
  showUrgencyBanner = true,
  heroVariant = 'stadium'
}: AppProps) {
  useEffect(() => {
    // Load the pixel after the page is interactive so it never blocks first paint.
    const idle = (window as typeof window & {
      requestIdleCallback?: (cb: () => void, opts?: {
        timeout: number;
      }) => number;
    }).requestIdleCallback;
    if (idle) {
      idle(() => initMetaPixel(), {
        timeout: 3000
      });
      return;
    }
    const id = window.setTimeout(initMetaPixel, 1200);
    return () => window.clearTimeout(id);
  }, []);
  return <div className="w-full bg-navy-950 font-sans" data-id="element-0" data-mp="7sxbo2oq39g">
      <main data-id="element-1" data-mp="2zmepackaxs9m">
        <Hero variant={heroVariant} data-id="element-2" data-mp="2zmo5j8fjol24" />
        <SocialProof data-id="element-3" data-mp="33movnqc0akp0" />
        <WhatYouGet data-id="element-4" data-mp="33m5e4aq9pybi" />
        <FinalCta data-id="element-5" data-mp="33ngdzzglelxc" />
        <Benefits data-id="element-6" data-mp="33myn7icp8zwt" />
        <FaqSection data-id="element-7" data-mp="33oi1j3esp0vy" />
        <InstantAccess showUrgency={showUrgencyBanner} data-id="element-8" data-mp="38m1f013o59mu" />
        <Guarantee data-id="element-9" data-mp="38kgmeh0x00rm" />
      </main>
      <SiteFooter data-id="element-10" data-mp="3dkurprb4swly" />
    </div>;
}